import {
  Button,
  Col,
  Row,
  Typography,
  Upload,
  UploadFile,
  UploadProps,
  message,
} from "antd";
import { RcFile } from "antd/lib/upload";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { uploadFilePath } from "../../../core/store/reducers/upload.slice";
export const readAsArrayBufferAsync = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};
function AdminDocumentUpload({
  setDocuments,
  attachmentMandatory = false,
  resetFiles = false,
}: any) {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileListData, setFileListData] = useState([] as any);
  const [uploading, setUploading] = useState(false);
  useEffect(() => {
    if (resetFiles == true) {
      setFileList([]);
      setFileListData([]);
      setUploading(false);
    }
  }, [resetFiles]);
  const dispatch = useDispatch();
  const handleUpload = async (file: any, ext: string) => {
    try {
      let uploadFileType = "";
      if (["png", "jpg", "jpeg", "gif"].includes(ext)) {
        uploadFileType = "image";
      } else if (["pdf"].includes(ext)) {
        uploadFileType = "pdf";
      } else if (["xls", "xlsx", "csv"].includes(ext)) {
        uploadFileType = "spreadsheet";
      } else if (["doc", "docx"].includes(ext)) {
        uploadFileType = "document";
      } else {
        message.error("Uploaded file is not valid", 10);
        removeFile(file);
        return;
      }
      const response = await dispatch(
        uploadFilePath({
          file_name: file.name,
          type: "TICKET",
          content_type: uploadFileType,
          display_url: false,
        })
      );

      const {
        data: {
          data: { id: upload_id, url },
        },
      } = response.payload;
      console.log(response.payload);
      try {
        const binaryFile = await readAsArrayBufferAsync(file as RcFile);
        setUploading(true);
        const fileUploaded = await axios.request({
          headers: { "Content-Type": file.type || "" },
          method: "PUT",
          data: binaryFile,
          url: url,
          timeout: 0,
        });
        if (fileUploaded.status === 200) {
          setUploading(false);
          const newList = [
            ...fileListData,
            { file, upload_id, url, fileUploaded: fileUploaded },
          ];
          setFileListData(newList);
          setDocuments(newList);
          // setDescription("");
          // setFileList([]);
        }
      } catch (e) {
        removeFile(file);
        message.error("Something went wrong.", 10);
      }
    } catch (e) {
      removeFile(file);
      message.error("Something went wrong.", 10);
    }
  };
  const removeFile = (file: any) => {
    const index = fileListData.indexOf(file);
    const newFileList = fileList.slice();
    newFileList.splice(index, 1);
    setFileList(newFileList);
    const newFileListData = fileListData.slice();
    newFileListData.splice(index, 1);
    setFileListData(newFileListData);
    setDocuments(newFileListData);
  };
  const props: UploadProps = {
    // accept: "image/jpg,image/jpeg,image/png,image/gif",
    showUploadList: false,
    onRemove: (file) => {
      removeFile(file);
    },
    beforeUpload: (file) => {
      const maxSizeInBytes = 5 * 1024 * 1024; // 2 MB in bytes
      if (file.size > maxSizeInBytes) {
        message.warning("File size must be up to 5 MB", 10);
        return false;
      }
      if (fileListData.length >= 5) {
        message.warning("You can only upload max 5 files", 10);
        return false;
      }
      const { name } = file;
      let ext: any = name?.split(".");
      ext = ext?.length > 0 ? ext[ext.length - 1] : "";
      if (
        [
          "png",
          "jpg",
          "jpeg",
          "gif",
          "pdf",
          "xls",
          "xlsx",
          "csv",
          "doc",
          "docx",
        ].includes(ext)
      ) {
      } else {
        message.error("Uploaded file is not valid", 10);
        return;
      }

      setFileList([...fileList, file]);
      setFileListData([...fileListData, { file }]);
      handleUpload(file, ext);
      return false;
    },
    maxCount: 3,
    fileList,
  };
  return (
    <>
      <Row>
        <Col className="pt-2 ant-form-item-label" span={24}>
          <label
            className={attachmentMandatory ? `ant-form-item-required` : ""}
          >
            Attachment
          </label>{" "}
          <span>(max size 5mb upto 5 documents)</span>
        </Col>
      </Row>
      <Row gutter={16} className="upload_doc">
        {fileListData?.map((val: any) => {
          return (
            <Col span={24}>
              <Row className="im-block">
                <Col style={{ width: "calc(100% - 20px)" }}>
                  <Typography.Text style={{ width: "100%" }} ellipsis={true}>
                    {val.file.name}
                  </Typography.Text>
                </Col>
                <Col style={{ width: "20px" }}>
                  <a className="delete-btn" onClick={() => removeFile(val)}>
                    &times;
                  </a>
                </Col>
              </Row>
            </Col>
          );
        })}
        <Col span={24}>
          <Upload {...props}>
            <Button
              size="large"
              block
              // onClick={handleUpload}
              // disabled={fileList.length === 0 || !description}
              loading={uploading}
            >
              {uploading ? "Uploading" : "Upload File"}
            </Button>
          </Upload>
        </Col>
      </Row>
    </>
  );
}

export default AdminDocumentUpload;
